import { reduxActions as APP } from "_constants/app.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const componentDrawing = {
  [APP.COMPONENTDRAWING_STARTED]: (state) => ({
    ...state,
    componentDrawing: {
      ...state.componentDrawing,
      status: LOADING
    }
  }),

  [APP.COMPONENTDRAWING_FAIL]: (state, { payload }) => ({
    ...state,
    componentDrawing: {
      ...state.componentDrawing,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [APP.COMPONENTDRAWING_SUCCESS]: (state, { payload }) => ({
    ...state,
    componentDrawing: {
      ...state.componentDrawing,
      data: payload?.data?.[0]?.data?.nbsk ?? null,
      status: SUCCESS
    }
  }),
  [APP.COMPONENTDRAWING_SET]: (state, { payload }) => ({
    ...state,
    componentDrawing: {
      ...state.componentDrawing,
      data: payload?.data ?? null,
      error: null,
      status: SUCCESS
    }
  })
};

export default componentDrawing;
